import { BodyText, Heading, TabGroup } from '@postscript/components';
import { useState } from 'react';
import { StyledBlockHeading } from '../Layout/SimpleStyledComponents';
import SystemBlock from '../Layout/SystemBlock';
import FoundationsColor from './Foundations/Color';
import FoundationsCopy from './Foundations/Copy';
import FoundationsForms from './Foundations/Forms';
import FoundationsLayout from './Foundations/Layout';
import FoundationsPatterns from './Foundations/Patterns';
import FoundationsTypography from './Foundations/Typography';

export interface FoundationsProps {
  selected: boolean;
}

const FoundationsSection = (): JSX.Element => {
  const [currentFoundationsPanel, setCurrentFoundationsPanel] =
    useState('color');

  return (
    <SystemBlock id="foundations">
      <StyledBlockHeading>
        <Heading as="h2" size="small">
          Foundations
        </Heading>
        <BodyText size="large">
          Explore the core brand and learn how we create great experiences.
        </BodyText>
      </StyledBlockHeading>

      <div>
        <TabGroup
          description="Explore the Emoji design foundations"
          id="design-foundations-tabgroup"
          style={{ marginBottom: 'var(--spacing-1)' }}
          placement="page-level"
        >
          <button
            data-tabpanel="foundations-color"
            data-selected={currentFoundationsPanel === 'color'}
            onClick={() => {
              setCurrentFoundationsPanel('color');
            }}
            type="button"
          >
            Color
          </button>
          <button
            data-tabpanel="foundations-typography"
            data-selected={currentFoundationsPanel === 'typography'}
            onClick={() => {
              setCurrentFoundationsPanel('typography');
            }}
            type="button"
          >
            Typography
          </button>
          <button
            data-tabpanel="foundations-layout"
            data-selected={currentFoundationsPanel === 'layout'}
            onClick={() => {
              setCurrentFoundationsPanel('layout');
            }}
            type="button"
          >
            Layout
          </button>
          <button
            data-tabpanel="foundations-copy"
            data-selected={currentFoundationsPanel === 'copy'}
            onClick={() => {
              setCurrentFoundationsPanel('copy');
            }}
            type="button"
          >
            Copy
          </button>
          <button
            data-tabpanel="foundations-patterns"
            data-selected={currentFoundationsPanel === 'patterns'}
            onClick={() => {
              setCurrentFoundationsPanel('patterns');
            }}
            type="button"
          >
            Patterns
          </button>
          <button
            data-tabpanel="foundations-forms"
            data-selected={currentFoundationsPanel === 'forms'}
            onClick={() => {
              setCurrentFoundationsPanel('forms');
            }}
            type="button"
          >
            Creating Forms
          </button>
        </TabGroup>

        <FoundationsColor selected={currentFoundationsPanel === 'color'} />
        <FoundationsTypography
          selected={currentFoundationsPanel === 'typography'}
        />
        <FoundationsLayout selected={currentFoundationsPanel === 'layout'} />
        <FoundationsCopy selected={currentFoundationsPanel === 'copy'} />
        <FoundationsPatterns
          selected={currentFoundationsPanel === 'patterns'}
        />
        <FoundationsForms selected={currentFoundationsPanel === 'forms'} />
      </div>
    </SystemBlock>
  );
};

export default FoundationsSection;
